document.addEventListener("DOMContentLoaded", function () {
  const newsletterModal = document.querySelector(".newsletter-modal");
  const shadow = document.querySelector(".newsletter-modal__overlay");
  const closeButton = document.querySelector(".newsletter-modal__close");

  let isOpen = false;

  const showNewsletterModal = () => {
    isOpen = true;
    newsletterModal.classList.add("open");
    shadow.classList.add("open");
  };

  const hideNewsletterModal = () => {
    isOpen = false;
    newsletterModal.classList.remove("open");
    shadow.classList.remove("open");
    if (window.location.hash === "#newsletterModal") {
      window.history.pushState("", document.title, window.location.pathname);
    }
  };

  closeButton.addEventListener("click", function () {
    hideNewsletterModal();
  });

  document.addEventListener("keyup", (event) => {
    if (isOpen && event.key === "Escape") {
      hideNewsletterModal();
    }
  });

  window.addEventListener("click", (event) => {
    if (isOpen && !event.target.closest(".newsletter-modal")) {
      hideNewsletterModal();
    }
  });

  if (document.body.classList.contains("template-index")) {
    const cookieName = "newsletterModalShown";

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    function getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
        const [key, value] = cookies[i].split("=");
        if (key === name) {
          return value;
        }
      }
      return null;
    }

    if (window.location.hash === "#newsletterModal") {
      showNewsletterModal();
    }
    window.addEventListener("scroll", function () {
      const scrollPosition = window.scrollY + window.innerHeight;
      const halfPageHeight = document.body.scrollHeight / 2;

      if (
        !getCookie(cookieName) &&
        newsletterModal.dataset.modalenabled == "true"
      ) {
        if (scrollPosition >= halfPageHeight) {
          showNewsletterModal();
          setCookie(cookieName, "true", 365);
        }
      }
    });
  }
});
